import { useState } from 'react';

interface VehicleImageProps {
  src: string;
  alt: string;
  title?: string;
  className?: string;
}

export default function VehicleImage({ src, alt, title, className = '' }: VehicleImageProps) {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-gray-900 ${className}`}>
        <div className="text-center text-gray-600">
          <i className="ri-car-line text-4xl mb-2 block"></i>
          <span className="text-xs">VIP Luxury Cars MKS</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
          <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        title={title}
        className={`${className} ${loaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        loading="lazy"
      />
    </>
  );
}
